import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'
import axios from '@/lib/axios'

const useGasMeters = () => {
    const { activeOrg } = useAuth()
    const activeOrgId = activeOrg?.id
    const hasGas = Boolean(activeOrg?.has_gas)

    return useQuery({
        queryKey: ['gasMeters', activeOrgId],
        queryFn: () =>
            axios.get(endPoints.GAS_METERS).then((response) => response.data),
        enabled: Boolean(activeOrgId) && hasGas,
        staleTime: 1000 * 60 * 2,
        placeholderData: () => []
    })
}

export default useGasMeters
